// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveGlobalPlanTagMutationVariables = Types.Exact<{
  input: Types.SaveGlobalPlanTagInput;
}>;


export type SaveGlobalPlanTagMutation = { __typename?: 'Mutation', saveGlobalPlanTag: { __typename?: 'SaveGlobalPlanTagResult', globalPlanTag: { __typename?: 'GlobalPlanTag', id: string, tasks: Array<{ __typename?: 'GlobalPlanTask', id: string }> } } };


export const SaveGlobalPlanTagDocument = gql`
    mutation SaveGlobalPlanTag($input: SaveGlobalPlanTagInput!) {
  saveGlobalPlanTag(input: $input) {
    globalPlanTag {
      id
      tasks {
        id
      }
    }
  }
}
    `;

/**
 * __useSaveGlobalPlanTagMutation__
 *
 * To run a mutation, you first call `useSaveGlobalPlanTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGlobalPlanTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGlobalPlanTagMutation, { data, loading, error }] = useSaveGlobalPlanTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveGlobalPlanTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveGlobalPlanTagMutation, SaveGlobalPlanTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveGlobalPlanTagMutation, SaveGlobalPlanTagMutationVariables>(SaveGlobalPlanTagDocument, options);
      }
export type SaveGlobalPlanTagMutationHookResult = ReturnType<typeof useSaveGlobalPlanTagMutation>;
export type SaveGlobalPlanTagMutationResult = ApolloReactCommon.MutationResult<SaveGlobalPlanTagMutation>;